// FilterBar.js - Combined filter controls + export button
import React from 'react';
import { FiDownload, FiRefreshCw } from 'react-icons/fi';
import DateRangePicker from './filters/DateRangePicker';
import MultiSelect from './filters/MultiSelect';

const FilterBar = ({
  // Date range
  period,
  onPeriodChange,
  startDate,
  endDate,
  onDateChange,
  // Source filter
  sources = [],
  selectedSources = [],
  onSourceChange,
  // Order type filter
  orderTypes = [],
  selectedOrderTypes = [],
  onOrderTypeChange,
  // Tag filter
  availableTags = [],
  selectedTag = '',
  onTagChange,
  // Item search
  itemSearch = '',
  onItemSearchChange,
  onItemSearchApply,
  // Actions
  onRefresh,
  onExport,
  loading = false
}) => {
  return (
    <div className="bg-gray-800 rounded-lg p-4 mb-6">
      <div className="flex flex-wrap items-center gap-4">
        {/* Date Range Picker */}
        <DateRangePicker
          value={period}
          onChange={onPeriodChange}
          startDate={startDate}
          endDate={endDate}
          onDateChange={onDateChange}
        />

        {/* Source Filter */}
        {sources.length > 0 && (
          <MultiSelect
            options={sources}
            value={selectedSources}
            onChange={onSourceChange}
            placeholder="All Sources"
            allLabel="All Sources"
          />
        )}

        {/* Order Type Filter */}
        {orderTypes.length > 0 && (
          <MultiSelect
            options={orderTypes}
            value={selectedOrderTypes}
            onChange={onOrderTypeChange}
            placeholder="All Types"
            allLabel="All Types"
          />
        )}

        {/* Tag Filter */}
        {availableTags.length > 0 && (
          <select
            value={selectedTag}
            onChange={e => onTagChange(e.target.value)}
            className="bg-gray-700 text-white text-sm px-2 py-1.5 rounded border border-gray-600"
          >
            <option value="">All Tags</option>
            {availableTags.map(tag => (
              <option key={tag} value={tag}>{tag}</option>
            ))}
          </select>
        )}

        {/* Item Search */}
        <input
          type="text"
          placeholder="Filter by item..."
          value={itemSearch}
          onChange={e => onItemSearchChange(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && onItemSearchApply && onItemSearchApply()}
          className="bg-gray-700 text-white text-sm px-3 py-1.5 rounded border border-gray-600 w-40"
        />

        {/* Spacer */}
        <div className="flex-1" />

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          <button
            onClick={onRefresh}
            disabled={loading}
            className="flex items-center gap-2 bg-gray-700 hover:bg-gray-600 disabled:opacity-50 text-white px-3 py-2 rounded transition-colors"
            title="Refresh"
          >
            <FiRefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            <span className="hidden sm:inline text-sm">Refresh</span>
          </button>

          <button
            onClick={onExport}
            disabled={loading}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white px-3 py-2 rounded transition-colors"
            title="Export CSV"
          >
            <FiDownload className="w-4 h-4" />
            <span className="hidden sm:inline text-sm">Export</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
